export const paths = {
  any: '*',
  dashboard: '/dashboard',
  organizations: {
    root: '/organizations',
    details: {
      root: '/organizations/:organizationId',
      tab: '/organizations/:organizationId/:tab',
      vendors: '/organizations/:organizationId/vendors/:vendorId',
      vendorsTab: {
        root: '/organizations/:organizationId/vendors/:vendorId/:subTab',
        children: {
          details: ':vendorId/:subTab',
        },
      },
      auditDetails: '/organizations/:organizationId/audits/:auditId',
      documentsPreview:
        '/organizations/:organizationId/documents/preview/:documentId',
      documentsViewer:
        '/organizations/:organizationId/documents/document/:documentId',
    },
  },
  projects: {
    root: '/projects',
    new: '/projects/new',
    details: {
      root: '/projects/:projectId',
      tab: '/projects/:projectId/:tab',
    },
    children: {
      details: ':projectId',
    },
  },
  vendors: {
    root: '/vendors',
    details: {
      root: '/vendors/:vendorId',
      tab: '/vendors/:vendorId/:tab',
    },
  },
  login: '/login',
  redirect: '/redirect',
  storybook: '/storybook',
} as const;
